import * as ENV from 'root/settings'

export const getSchema = (schema) => {
    let DEV = ENV.MODE_DEV
    let PROD = ENV.MODE_PROD
    // Add additional db modes here and ensure each schema exports added mode
    // ...
    const { [DEV]: SCHEMA_DEV, [PROD]: SCHEMA_PROD } = schema
    switch (ENV.FIREBASE_DB_MODE) {
        case ENV.MODE_DEV:
            return SCHEMA_DEV
        case ENV.MODE_PROD:
            return SCHEMA_PROD
        default:
            throw new Error('Db mode not set. Please refer to settings.')
    }
}
